import { Image } from 'react-native';

import { useTranslation } from '@/i18n';

const REFERENCE_WIDTH = 412;
const REFERENCE_HEIGHT = 407;
const IMAGE_WIDTH = 257;
const IMAGE_HEIGHT = 275;

const sourceEn = require('@/../assets/illustrations/onboarding-welcome.png');
const sourceJa = require('@/../assets/illustrations/onboarding-welcome.ja.png');

interface IllustrationProps {
  readonly width: number;
  readonly height: number;
}

export const OnboardingWelcomeIllustration = ({ width, height }: IllustrationProps) => {
  const { locale } = useTranslation();
  const source = locale === 'ja' ? sourceJa : sourceEn;
  const scale = Math.min(width / REFERENCE_WIDTH, height / REFERENCE_HEIGHT);
  return (
    <Image
      source={source}
      style={{ width: IMAGE_WIDTH * scale, height: IMAGE_HEIGHT * scale }}
      testID="onboarding-welcome-illustration"
    />
  );
};
